import { Container, Row } from 'react-bootstrap';

const Home: React.FC = () => {
  return (
    <Container fluid className="vh-100">
      <Row className="h-100">
        <h4>Dashboard</h4>
        <p>Bienvenido al panel de administración.</p>
      </Row>
    </Container>
  );
};

export default Home;
